import { IProvider, ManagementType } from "./ExternalProvider";

export enum ResourcePermission {
    MANAGE = 'manage',
    READ = 'read'
}

export enum UserStatus {
    ACTIVE = 'active',
    ARCHIVE = 'archive',
    INACTIVE = 'Inactive'
}

export enum GrantType {
    DIRECT = 'direct',
    INFERRED = 'inferred'
}

export enum AllUsersSortByType {
    USERNAME = "username",
    FIRST_NAME = "firstname",
    LAST_NAME = "lastname",
    JOB_ROLE = "jobrole",
    WORKSPACES = "workspaces",
    PERMISSIONS = "permissions",
    STATUS = "status",
    GROUPS = "name",
    MEMBERS = "members"
}

export interface DropdownGroupInfo {
    title: string;
    subtitle: string;
    displayIcon: boolean;
    icon: any;
};

//USERS:
export interface IUserData {
    id: number,
	firstName: string,
	lastName: string,
    userName: string,
    permission: ResourcePermission,
    grantType: GrantType,
    profilePicUrl: string,
    jobRole: string,
    status: UserStatus,
    userManagementType: ManagementType,
    provider?: IProvider
}

export interface IUserPermission {
    permission: ResourcePermission
}

export interface IBasicGroupDetails {
    name: string,
    permission: ResourcePermission,
    grantType: GrantType,
}

export interface IBasicGroup {
    records: IBasicGroupDetails[],
    total: number
}

//USER GROUPS
export interface IUserGroupData {
    id: number,
	name: string,
	totalMembers: number,
    totalWorkspaces: string, 
    profilePictureUrls: string[],
    permission: ResourcePermission,
    status: UserStatus,
    canBeModified?: boolean,
    groupManagementType: ManagementType,
	provider?: IProvider
}

export interface IWorkspaceUserGroupData {
    id: number,
	name: string,
	totalMembers: number,
    totalWorkspaces: string, 
    profilePictureUrls: string[],
    permission: ResourcePermission,
    grantType: GrantType,
    status: UserStatus,
    groupManagementType: ManagementType,
	provider?: IProvider
}

export interface IGroupIconsAndName {
    profilePictures: string[], 
    userGroupId: number, 
    userGroupName: string, 
    hasNoMembers: boolean, 
    truncate: number, 
    isManagedGroup?: boolean, 
    externalLoginIcon?: string
}

export interface IUserIconAndName {
    profilePicture: string, 
    userId: number, 
    username: string, 
    truncate: number
    isManagedUser?: boolean,
    externalLoginIcon?: string
}